<div class="container-fluid fill-height">
    <div class="row">
        <div class="pnl-header col-12">
            <app-header></app-header>
        </div>
        <div class="pnl-content col-12" style="padding-left:0; padding-right:0">
            <app-register></app-register>
        </div>
        <div class="pnl-footer col-12">
            <app-footer></app-footer>
        </div>
    </div>
</div>